import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingKolkata from "../components/blogs/DigitalMarketingKolkata";

const DigitalMarketingAgencyKolkata = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Kolkata | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Choose SMS ZOO ZOO, a performance-driven digital marketing agency in Kolkata, to generate leads, increase traffic, and scale online growth."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-kolkata"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingKolkata />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyKolkata;
